import script from "./BpXj.vue?vue&type=script&setup=true&lang=js"
export * from "./BpXj.vue?vue&type=script&setup=true&lang=js"

import "./BpXj.vue?vue&type=style&index=0&id=ac5d7e42&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ac5d7e42"]])

export default __exports__